import { useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Clear, Search } from "src/components/svg";
import { Loading } from "src/components/ui";
import { ProgramType } from "src/enums";
import { _ } from "src/services";
import { ArchiveList, ArchiveListAction } from "src/store";

export const ArchiveSearch: React.FC = () => {

    //#region dependencies

    const dispatch = useDispatch();
    const list: ArchiveList = useSelector((state: any) => state.ArchiveListState);

    //#endregion

    //#region properties

    const searchTime = useRef<NodeJS.Timeout | null>();

    //#endregion

    //region mehtods

    const fetchData = useCallback((text: string) => {

        if (list.loading) return;

        dispatch(ArchiveListAction.getData(list.count, ProgramType.ArchiveVideo, 0, text, true));
    }, [dispatch, list]);

    const clearSearch = () => {
        dispatch(ArchiveListAction.setSearchText(""));
        fetchData("");
    };

    const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {

        const value = e.target.value;
        dispatch(ArchiveListAction.setSearchText(value));

        if (searchTime && searchTime.current) {
            clearTimeout(searchTime.current);
        }

        searchTime.current = setTimeout(() => {
            fetchData(value);

        }, 500);
    };

    //#endregion

    return (
        <div className="container p-sm-0 text-center">
            <div className="input-group search-input-area">
                {
                    list.searchText && !list.loading &&
                    <button className="clear-button button-unstyled" onClick={clearSearch}>
                        <span className="clear-icon">
                            <Clear />
                        </span>
                    </button>
                }
                {
                    list.searchText && list.loading &&
                    <span className="lottie mt-1 ml-1">
                        <Loading />
                    </span>
                }
                <input type="text" className="form-control search-input" aria-describedby="inputGroup-sizing-sm"
                    value={list.searchText} onChange={onChange}
                    placeholder={_("archiveSearchPlaceholder")}
                />
                <button className="search-button button-unstyled">
                    <span className="search-icon">
                        <Search />
                    </span>
                </button>
            </div>
        </div>
    );

};